import { render, staticRenderFns } from "./view.html?vue&type=template&id=57c29c55&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=57c29c55&lang=less&scoped=true&"
import style1 from "./phoneStyle.less?vue&type=style&index=1&id=57c29c55&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c29c55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c29c55')) {
      api.createRecord('57c29c55', component.options)
    } else {
      api.reload('57c29c55', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=57c29c55&scoped=true&", function () {
      api.rerender('57c29c55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/multiplePeopleCase/multiplePeopleCase_list/index.vue"
export default component.exports